import { render } from "./SendRequest.vue?vue&type=template&id=a9402354&scoped=true"
import script from "./SendRequest.vue?vue&type=script&lang=js"
export * from "./SendRequest.vue?vue&type=script&lang=js"

import "./SendRequest.vue?vue&type=style&index=0&id=a9402354&scoped=true&lang=css"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\auto-portalV2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9402354"]])

export default __exports__